import React from 'react';
import { useState } from 'react';
import EventApi from '../../../Api/EventApi';
import { getResponseError } from '../../../Api/Utils/apiUtils';
import ErrorAlert from '../../Form/ErrorAlert/ErrorAlert';

const AddGuest = ({setToBack, ID}) => {
    const [name, setname] = useState('');
    const [email, setemail] = useState('');
    const [mobilenumber, setmobilenumber] = useState('');
    const [errorMessage, seterrorMessage] = useState(null);

    const addtoGuestList = async () => {
        const guestdate = {
            eventId: parseInt(ID),
            userName: name,
            emailAddress: email,
            mobileNumber: mobilenumber
        }
        const response = await EventApi.addGuesttolist(guestdate)
        const responseApiError = getResponseError(response)
        if (responseApiError) {
            seterrorMessage(responseApiError)
        }else{
            if (response.success === 'true') {
                setname('')
                setemail('')
                setmobilenumber('')
                window.location.reload()
            }
        }
    }

    return (
        <div className="add-guest-section">
        <div className="add-guest-container">
            <div className="add-guest">
                <h4>Add Guest</h4>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <div className="name">
                    <input type="text" value={name} onChange={(e) => setname(e.target.value)} placeholder='User Name' />
                </div>
                <div className="email">
                    <input type="text" value={email} onChange={(e) => setemail(e.target.value)} placeholder='Email Address' />
                </div>
                <div className="phone">
                    <input type="text" value={mobilenumber} onChange={(e) => setmobilenumber(e.target.value)} placeholder='Mobile Number' />
                </div>
                <div className="buttons">
                    <button onClick={addtoGuestList}>Add to Guest List</button>
                    <button className='cancle' onClick={() => setToBack(false)}>Cancle</button>
                </div>
            </div>
        </div>
        </div>
    );
};

export default AddGuest;
